export const currentUser = {
  name: "Camille D.",
  status: "Membre Shuttle Silver",
  crossings: 14,
  avatarInitial: "C",
}

export const recentTrips = [
  { id: "t1", label: "Folkestone → Calais · 24 août" },
  { id: "t2", label: "Calais → Folkestone · 18 août" },
  { id: "t3", label: "Folkestone → Calais · 2 juillet" },
]

export const questionnaire = [
  { id: "embarquement", label: "Fluidité de l'embarquement" },
  { id: "confort", label: "Confort à bord" },
  { id: "accueil", label: "Accueil des équipes" },
]

export type BonPlan = {
  id: string
  name: string
  category: "Activité" | "Culture" | "Séjour" | "Restaurant"
  discount: string
  description: string
  location: string
}

export const bonsPlans: BonPlan[] = [
  {
    id: "bp1",
    name: "Parc Astérix",
    category: "Activité",
    discount: "-30%",
    description: "Entrée famille en coupe-file",
    location: "Plailly, Oise",
  },
  {
    id: "bp2",
    name: "Canterbury Cathedral",
    category: "Culture",
    discount: "-25%",
    description: "Visite guidée + audioguide",
    location: "Canterbury, Kent",
  },
  {
    id: "bp3",
    name: "Domaine des Deux Caps",
    category: "Séjour",
    discount: "-20%",
    description: "2 nuits en gîte face à la mer",
    location: "Cap Blanc-Nez",
  },
  {
    id: "bp4",
    name: "Le Channel",
    category: "Restaurant",
    discount: "-15%",
    description: "Menu du terroir 3 services",
    location: "Calais",
  },
  {
    id: "bp5",
    name: "Battle of Britain Memorial",
    category: "Culture",
    discount: "-40%",
    description: "Pass duo + expo immersive",
    location: "Folkestone",
  },
  {
    id: "bp6",
    name: "Aqualud Le Touquet",
    category: "Activité",
    discount: "-25%",
    description: "Journée illimitée",
    location: "Le Touquet",
  },
]

export const bonsPlansCategories = ["Tout", "Activité", "Séjour", "Restaurant", "Culture"] as const

export const communautePostCategories = [
  "Bon plan",
  "Astuce",
  "Lieu inédit",
  "Restauration",
  "Itinéraire",
  "Question",
] as const

export type CommunautePost = {
  id: string
  author: string
  location: string
  timeAgo: string
  type: (typeof communautePostCategories)[number]
  content: string
  likes: number
}

export const communautePosts: CommunautePost[] = [
  {
    id: "c1",
    author: "Camille D.",
    location: "Côte d'Opale",
    timeAgo: "il y a 2h",
    type: "Astuce",
    content: "Partez sur la navette de 6h20, aucune file d'attente et vous êtes à Wissant pour le petit-déj.",
    likes: 34,
  },
  {
    id: "c2",
    author: "Tom & Léa",
    location: "Canterbury",
    timeAgo: "hier",
    type: "Bon plan",
    content: "Le partenariat Canterbury Cathedral (-25 %) vaut vraiment le détour, on y a passé la matinée entière.",
    likes: 21,
  },
  {
    id: "c3",
    author: "Farid B.",
    location: "Folkestone",
    timeAgo: "il y a 3j",
    type: "Astuce",
    content: "Pour les chiens : la zone pet-friendly du terminal est bien plus calme côté parking C.",
    likes: 12,
  },
]
